export default __webpack_public_path__ + "static/media/817.f1681cff.png";